/**
 * @packageDocumentation
 * @module f1/is
 */

/**
 * @param y second value
 */
export type IsEqualValue = (y: unknown) => boolean;

export interface IsEqual {
  /**
   * Are two values equal of type (`===`)
   *
   * @public
   * @function f1.is.equal
   * @param x first value
   * @param y second value
   * @example
   *
   * ```ts
   * f1.is.equal(true, true) => true
   * f1.is.equal('true', true) => false
   * ```
   */
  (x: unknown, y: unknown): boolean;
  /**
   * @param x first value
   */
  (x: unknown): IsEqualValue;
}

/**
 * @see IsEqual
 */
export default (x: unknown, y: unknown) => x === y;
